




































import _ from 'lodash';
import {Component, Vue} from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';

import { Setting as mainTerms} from '@/const/terms/mainTerms';
import { EditAdFolder as feedbackTerms } from '@/const/terms/feedback/adFolder';

import { IAPP, ID_TYPE, AD_FORMAT_KEY, AD_FORMAT } from '@/const/types';
import { StorageCustomerInfo } from '@/store/user/types';
import {
    FormType,
    ICreative,
    ISortedInventory,
    IInventory,
    IFormatData,
    FormResponse,
    IFormatResponse,
    ICreativeResponse,
 } from './editingTypes';
import { InitialFormData } from './editingData';

import { Form as ElForm } from 'element-ui';
import { ElUploadInternalFileDetail } from 'element-ui/types/upload';
import { AxiosError, AxiosResponse } from 'axios';

import AdFolderForm from '@/components/pages/adFolder/AdFolderForm.vue';

const userModule = namespace('User');

@Component<AdFolderEdit>({
    name: 'AdFolderEdit',
    components: {
        AdFolderForm,
    },
    beforeRouteLeave (to: any, from: any, next: any) {
        if (this.isSubmit || to.name === 'login') {
            next();
        } else {
            this.$confirm(feedbackTerms.other.confirm.warnIsModified,'Warning', {
                confirmButtonText: '네',
                cancelButtonText: '아니오',
                type: 'warning'
            }).then((confirm: any) => {
                next();
            })
            .catch(() => {})
        }
    }
})
export default class AdFolderEdit extends Vue {
    private terms = mainTerms;
   
    private isSubmit: boolean = false;
    private loading: boolean = false;
    private subLoading: number = 0;

    private form: FormType = _.cloneDeep(InitialFormData);
    private appList: IAPP[] = [];

    private postPrefix: string = '';
    private preventPostMessage: boolean = false;
    private parentWindow: Window | null = null; 
    
    @userModule.State(state => state.customerInfo) private customerInfo!: StorageCustomerInfo;

    get whichLocation() {
        return this.$route.path.split('/').splice(-1, 1)[0].toLowerCase();
    }
    
    get isEdit() {
        return (this.$route.params && this.$route.params.adFolderID && true) === true;
    }

    get tableData() {
        this.form.formats.forEach((item: IFormatData) => {
            const doneApps: ID_TYPE[] = [];
            item.sortedInventories = item.inventories.reduce((pre: ISortedInventory[], curr: IInventory) => {
                const key = curr.appKey;
                if(doneApps.includes(key)) 
                    return pre;
                
                doneApps.push(key);
                const match =   item.inventories
                                .filter((inv: IInventory) => inv.appKey === key)
                                .sort((a: IInventory, b: IInventory) => a.name < b.name ? -1 : 1);
                return [
                    ...pre,
                    {
                        appKey: key,
                        inventories: match,
                    }
                ] as ISortedInventory[];
            }, [])
            .sort((a: ISortedInventory, b: ISortedInventory) => a.appKey < b.appKey ? -1 : 1);
        });
        return this.form.formats.sort((a: IFormatData,b: IFormatData) => {
            if (a.sspFormat === b.sspFormat) {
                return a.format < b.format ? -1 : 1;
            }
            return a.sspFormat < b.sspFormat ? -1 : 1;
        });
    }
    private handleChange(file: ElUploadInternalFileDetail, fileList: ElUploadInternalFileDetail[], row: IFormatData ) {
        let link = '';
        this.uploadCreative(file, row).then((res: any) => res.data)
            .then((data: {result: boolean, link: string}) => {
                if (data && data.result) {
                    link = data.link;
                    row.creatives.push({
                        id: 0,
                        url: link,
                        alt: '',
                        deleted: false,
                    })
                    return;
                }
                throw new Error(feedbackTerms.upload.error.fail)
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    if ((err.response as AxiosResponse).data.error_msg === 'invalid image size') {
                        this.$notify.error(feedbackTerms.upload.error.notExactSize);
                        return;
                    }
                    if ((err.response as AxiosResponse).data.error_msg === 'image: unknown format') {
                        this.$notify.error(feedbackTerms.upload.error.notValidFormat);
                        return;
                    }
                } 
                this.$notify.error(err.message);
                throw err;
            })
            .finally(() => {
                fileList.pop();
            })
    }
    
    private cancelForm() {
        this.$router.push({name: 'adFolder'});
    }
    private validateForm() {
        const formWrapper = this.$refs.formWrapper as AdFolderForm;
        const form = formWrapper.$refs.form as ElForm;
        form.validate().then((valid: boolean) => {
            if (valid) {
                if (this.isEdit) {
                    this.submitForEdit(form.model as FormType).then((res: any) => res.data)
                        .then((data: {result: boolean}) => {
                            if (data && data.result) {
                                this.$notify.success(feedbackTerms.editing.success);
                                this.isSubmit = true;
                                if (this.parentWindow) {
                                    this.preventPostMessage = true;
                                    const parentWindow = this.parentWindow;
                                    parentWindow.postMessage(this.postPrefix + 'true', parentWindow.origin);
                                    window.close();
                                }
                                this.$router.push({name: 'adFolder'});
                            } else {
                                this.$notify.error(feedbackTerms.editing.error.fail);
                                if (this.parentWindow) {
                                    const parentWindow = this.parentWindow;
                                    parentWindow.postMessage(this.postPrefix + 'false', parentWindow.origin);
                                }
                            }
                        })
                        .catch((err: AxiosError) => {
                            if (err.response && (err.response as AxiosResponse).status !== 200) {
                                this.$notify.error(feedbackTerms.editing.error.fail);
                                return;
                            }

                            this.$notify.error(err.message);
                        })
                } else {
                    this.submitForNew(form.model as FormType).then((res: any) => res.data)
                        .then((data: {result: boolean, folder_id: ID_TYPE}) => {
                            if (data) {
                                this.$notify.success(feedbackTerms.new.success);
                                this.isSubmit = true;
                                if (this.parentWindow) {
                                    this.preventPostMessage = true;
                                    const parentWindow = this.parentWindow;
                                    parentWindow.postMessage( this.postPrefix + 'ready', parentWindow.origin);
                                }
                                this.$router.replace({
                                    name: 'adFolderEdit',
                                    params: {
                                        adFolderID: data.folder_id as string,
                                    },
                                });
                                return;
                            }
                            throw new Error(feedbackTerms.new.error.fail);
                        })
                        .catch((err: AxiosError)=>{
                            if (err.response && (err.response as AxiosResponse).status !== 200) this.$notify.error(feedbackTerms.new.error.fail);
                            else this.$notify.error(err.message);
                            if (this.parentWindow) {
                                const parentWindow = this.parentWindow;
                                parentWindow.postMessage(this.postPrefix+'false', parentWindow.origin);
                            }
                        })
                }
            } else {
                return false;
            }
        }).catch((err: boolean) => {
            if (err === false) {
                const errorField = (form as any).fields.find((f: any) => f.validateState === 'error') as Vue;
                if (errorField) {
                    const el = errorField.$el.querySelector('input') as HTMLElement;
                    el.focus();
                }
            }
        })
    }
    // private makeCreativeMeta(format: AD_FORMAT, link: string) {
    //     return this.$http.adserverAPI.post('SetCreativeInFolder', {
    //         id: this.form.id as ID_TYPE,
    //         format_no: format,
    //         url: link,
    //     })
    // }
    private uploadCreative(file: ElUploadInternalFileDetail, row: IFormatData) {
        const formData = new FormData();
        formData.append('company_no', this.customerInfo.company_no.toString());
        formData.append('folder_no', (this.form.id as ID_TYPE).toString());
        formData.append('width', row.format_raw.width.toString());
        formData.append('height', row.format_raw.height.toString());
        formData.append('file', file.raw);

        return this.$http.adserverAPI.post('UploadCreative', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }

    private submitForEdit(model: FormType) {
        const creatives = model.formats.reduce((pre: ICreative[], format: IFormatData) => {
            const eachCreatives = format.creatives.reduce((pre: ICreative[], creative: ICreative) => {
                const now = creative.id === 0 && creative.deleted ? null : {
                    id: creative.id,
                    format_no: format.format,
                    url: creative.url,
                    alt: creative.alt,
                    deleted: creative.deleted,
                };
                return now === null ? pre : [...pre, now];
            }, []);
            return [...pre, ...eachCreatives];
        }, []);
        return this.$http.adserverAPI.post('UpdateCreativeFolderInfo', {
            id: model.id as ID_TYPE,
            name: model.name.trim(),
            creatives: creatives,
        })
    }
    // private submitForEdit(model: FormType) {return Promise.resolve(JSON.parse(JSON.stringify({status: 200, data: true})))}
    private submitForNew(model: FormType){
        return this.$http.adserverAPI.post('CreateCreativeFolder', {
            name: model.name.trim(),
        });
    }
    // private submitForNew(model: FormType) {return Promise.resolve(JSON.parse(JSON.stringify({status: 200, data: {id: 1234}})))}

    private getAdFolderInfo() {
        return this.$http.adserverAPI.post('GetCreativeFolderInfo', {
            id: this.$route.params.adFolderID,
        });
    }

    private async created() {
        window.addEventListener('message', (e: any) => {
            if (!this.preventPostMessage && e.origin === window.origin && e.data === 'adFolderNewRequest') {
                this.parentWindow = e.source as Window;
                this.postPrefix = e.data;
                this.parentWindow.postMessage(this.postPrefix + 'connected', this.parentWindow.origin);
            }
        })
        if (this.isEdit) {
            this.loading = true;            
            await this.getAdFolderInfo().then((res: any) => res.data)
                .then((data: FormResponse) => {
                    if (data && (data as any).result === null) {
                        throw new Error(feedbackTerms.editing.error.notFound);
                    }
                    this.form.id = data.id;
                    this.form.name = data.name;
                    this.form.formats = data.formats.map((item: IFormatResponse)=> {
                        const key = AD_FORMAT_KEY(item.type, item.format_raw.width, item.format_raw.height);
                        const format = AD_FORMAT[key];
                        const creatives = item.creatives.map((creative: ICreativeResponse) => {
                            return {
                                ...creative,
                                deleted: false,
                            } as ICreative;
                        });
                        return {
                            ...item,
                            format: format,
                            uploads: [],
                            creatives: creatives,
                        }
                    });
                    this.appList = data.apps;
                })
                .catch((err: AxiosError) => {
                    if (err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(feedbackTerms.editing.error.getResponse);
                    } else {
                        this.$notify.error(err.message);
                        this.isSubmit = true;
                        this.$router.push({ name: 'adFolder' });
                    }
                    throw err;
                })
                .finally(()=>{
                    this.loading = false;
                })
        }
    }
}
